export enum UploadType {
  NONE,
  CSV_CUT,
  CSV_ELEVATION,
  CSV_MARKER
}
